<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('scope.upgrade') }}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('scope.ce_tech_support')" :count="params.data.length" :action="$t('scope.upgrade')" />
      <dialog-table :data="params.data" :columns="columns" />
      <div class="steps-container">
        <a-steps :current="2" label-placement="vertical">
          <a-step title="购买" :description="'按次购买' + $t('scope.technical_consulting') + '服务'" />
          <a-step :title="$t('scope.technical_consulting')" description="扫描二维码进入专属企业微信群进行问题咨询" />
          <a-step :title="$t('scope.remote_assistance') + '(可选)'" :description="'如果问题仅通过' + $t('scope.technical_consulting') + '无法解决，可购买升级为' + $t('scope.remote_assistance') + '服务'" />
          <a-step title="解决" description="问题解决，完成服务。7个自然日后专属企业微信群解散" />
        </a-steps>
      </div>
      <div>{{ $t('scope.remote_assistance') }}服务升级价格为{{ customerCapability.remote_origin_rate }}元/次，活动期间折扣价为{{ customerCapability.remote_rate }}元/次。确定支付<span class="discount-price">{{ customerCapability.remote_rate }}元</span>购买？</div>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SaasTechSupportUpgradeDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapState('app', {
      customerCapability: state => state.customerCapability,
    }),
    columns () {
      const showFields = ['name', 'status', 'created_at']
      return this.params.columns.filter((item) => { return showFields.includes(item.field) })
    },
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        const res = await this.params.onManager('performAction', {
          id: this.params.data[0].id,
          managerArgs: {
            action: 'escalate',
          },
        })
        this.loading = false
        this.cancelDialog()
        this.$message.success(this.$t('common.success'))
        // go to checkout page
        if (res.data.escalate_bill_id) {
          this.$router.push({ path: '/account/checkout', query: { bill_id: res.data.escalate_bill_id, from: 'tech-support' } })
        }
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .steps-container {
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 16px;
    ::v-deep .ant-steps-item-content {
      text-align: center;
      width: auto !important;
      max-width: 140px;
      white-space: normal;
    }
    ::v-deep .ant-steps-item-title {
      white-space: normal;
      line-height: 1.4;
      padding-right: 0 !important;
    }
    ::v-deep .ant-steps-item-description {
      white-space: normal;
      max-width: 140px;
      text-align: center;
      line-height: 1.4;
      padding-right: 0 !important;
    }
  }
  .discount-price {
    color: #ff4d4f;
    font-weight: bold;
  }
</style>
